/* istanbul ignore file -- @preserve This is a thin wrapper; logic is tested via GlobalErrorContent */
'use client';

import { GlobalErrorContent } from '@/components/ErrorScreens/GlobalErrorContent';

/**
 * Global error boundary component for Next.js App Router.
 *
 * This catches errors in the root layout and template components.
 * It must render a full HTML document including <html> and <body> tags.
 *
 * The actual error handling logic is in GlobalErrorContent for testability.
 *
 * @see https://nextjs.org/docs/app/api-reference/file-conventions/error#global-errorjs
 */
export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
    return (
        <html lang="en">
            <body style={{ margin: 0, padding: 0 }}>
                <GlobalErrorContent
                    error={error}
                    reset={reset}
                />
            </body>
        </html>
    );
}
